import { List } from "models/list";
import { FunctionComponent } from "react";
import Block from "components/layout/block";
import ListEntitiesTable from "components/list/entities-table";

interface EntitiesTabProps {
  listTemplate: List;
}

const EntitiesTab: FunctionComponent<EntitiesTabProps> = ({ listTemplate }) => {
  return (
    <Block title="Kerättävät kokonaisuudet">
      <ListEntitiesTable list={listTemplate} />
    </Block>
  );
};

export default EntitiesTab;
